import { useMemo } from 'react';
import classNames from 'classnames';

import { Button } from '../button.component';

interface ExpandButtonProps {
  expanded: boolean;
  onClick: () => void;
  testId?: string;
  darkBg?: boolean;
  blackButtonOnExpandedState?: boolean;
}

export const ExpandButton = ({ expanded, onClick, testId, darkBg, blackButtonOnExpandedState }: ExpandButtonProps) => {
  const styles = useMemo(
    () => ({
      button: {
        'snowflake-button-tertiary': true,
        'snowflake-button-blue': !darkBg && (!expanded || !blackButtonOnExpandedState),
        'snowflake-button-white': darkBg,
      },
    }),
    [darkBg, expanded, blackButtonOnExpandedState]
  );

  return (
    <div data-testid={testId || 'snowflake-expand-button'} onClick={onClick} className={classNames(styles.button)}>
      <Button appliedCssClassNames="snowflake-button-icon" icon={expanded ? 'collapse' : 'expand'} disableAnchor />
    </div>
  );
};
